<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0">
						<v-row>
							<v-col class="pb-0 pt-0">
								<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
									{{ $t('titles.candidateCertificates') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0">
								<TheTable
									:additional-filters="candidateCertificatesTable.additionalFilters"
									:default-sort="candidateCertificatesTable.defaultSort"
									:excel="false"
									:fields="candidateCertificatesTable.headers"
									:header-selection-key="'candidate-certificates-headers'"
									:height="candidateCertificatesTable.height"
									:total-records="candidateCertificatesTable.total"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in candidateCertificatesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
									>
										<td v-if="candidateCertificatesTable.selectedHeaders.includes('id')">
											{{ item.id }}
										</td>
										<td
											v-if="
												candidateCertificatesTable.selectedHeaders.includes(
													'certificate_number'
												)
											"
										>
											{{ item.certificate_number }}
										</td>
										<td
											v-if="candidateCertificatesTable.selectedHeaders.includes('certificate_id')"
										>
											{{ item.certificate != null ? item.certificate.name : '' }}
										</td>
										<td
											v-if="
												candidateCertificatesTable.selectedHeaders.includes('planned_course_id')
											"
										>
											{{
												item.course_id == null
													? item.planned_course
														? item.planned_course.course.code +
														  ' ' +
														  item.planned_course.course.name +
														  ' - ' +
														  item.planned_course.start_date
														: ''
													: item.course.code + ' ' + item.course.name
											}}
										</td>
										<td v-if="candidateCertificatesTable.selectedHeaders.includes('office_id')">
											{{ item.office != null ? item.office.name : '' }}
										</td>
										<td v-if="candidateCertificatesTable.selectedHeaders.includes('issue_date')">
											{{
												item.issue_date != null
													? item.issue_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="
												candidateCertificatesTable.selectedHeaders.includes('expiration_date')
											"
										>
											{{
												item.expiration_date != null
													? item.expiration_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td>
											<v-tooltip bottom v-if="!item.course_id">
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="getCertificatePdf(item.id)"
														v-on="on"
													>
														<v-icon small color="#ff0000">fas fa-file-pdf</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.getCertificatePdf') }}</span>
											</v-tooltip>
											<v-tooltip bottom v-if="item.certificate_file.upload_id">
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="downloadCertificate(item.certificate_file)"
														v-on="on"
													>
														<v-icon small color="#003a9e">fas fa-download</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.downloadFile') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'CandidateCertificates',
	components: { TheTable },
	data: function () {
		return {
			candidateCertificatesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.certificateNumber'),
						value: 'certificate_number',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.certificate'),
						value: 'certificate_id',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.course'),
						value: 'planned_course_id',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.office'),
						value: 'office_id',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.issueDate'),
						value: 'issue_date',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.expirationDate'),
						value: 'expiration_date',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: '',
						value: 'actions',
						type: '',
						sortable: false,
						width: '100px',
						allowFilter: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '400px',
				defaultSort: {
					field: 'issue_date',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.candidateCertificatesTable.selectedHeaders = headers;
		},
		downloadCertificate(file) {
			window.open(file.link);
		},
		getCertificatePdf(id) {
			let vm = this;
			this.$APICall2('get', 'issued-certificates/pdf/' + id, {}, (data, success) => {
				if (success) {
					const blob = new Blob([data], { type: 'application/pdf' });
					const url = URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = 'certifikat.pdf';
					this.downloadingPdf = false;
					link.click();
					URL.revokeObjectURL(url);
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		reloadData(request) {
			this.candidateCertificatesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'candidates-certificates/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.candidateCertificatesTable.items = data.items;
						vm.candidateCertificatesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			// this.candidateCertificatesTable.height = window.innerHeight - 720 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		// this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
